import React from "react";
import "./ShineBorder.css";

/**
 * Shine Border
 *
 * An animated background border effect component with configurable properties.
 */
export function ShineBorder({
  borderWidth = 1,
  duration = 20, // Slower default
  shineColor = "#FF6B2B",
  className = "",
  style = {},
  ...props
}) {
  return (
    <div
      style={{
        "--border-width": `${borderWidth}px`,
        "--duration": `${duration}s`,
        backgroundImage: `radial-gradient(circle at center, ${
          Array.isArray(shineColor) ? shineColor.join(",") : shineColor
        }, transparent 40%)`,
        backgroundSize: "200% 200%",
        mask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
        WebkitMask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        padding: "var(--border-width)",
        ...style,
      }}
      className={`shine-border-overlay ${className}`}
      {...props}
    />
  );
}
